import observeAndExecute from "../utils/observe-and-execute";

export default function (components = []) {
    if ( !components.length ) return;
    let createApp, defineAsyncComponent, isLoadVUE = false;

    async function loadVue() {
        if (isLoadVUE) return;
        isLoadVUE = true;
        const VUE = await import('vue');
        createApp = VUE.createApp;
        defineAsyncComponent = VUE.defineAsyncComponent;
        dispatchEvent(new Event('vue-load'));
    }

    for (const component of components) {
        observeAndExecute(`[data-vue-component*=${component.name}]`, {
            callback: async () => {
                if ( typeof component.isLoad !== 'undefined' && component.isLoad === true) return;
                component.isLoad = true;
                await loadVue();
                document.querySelectorAll(`.${component.name}`).forEach((el) => {
                    if ( !defineAsyncComponent || !createApp ) return;
                    const $VueApp = createApp({});

                    $VueApp.component(component.name, defineAsyncComponent({
                        loader: component.file,
                    }));

                    $VueApp.mount(el);
                    // dispatchEvent(new CustomEvent("vue-load-component", { detail: { name: component.name } }));
                });
            },
            disconnect: true,
            observerOptions: component.observerOptions ?? {},
        });
    }
}
